// cart-gift.js
const TRIGGER_PRODUCT_IDS = [10681172590897, 10681172525361, 10681137070385, 10681172295985, 10681173410097, 10681178390833];
const GIFT_PRODUCT_ID = 10681184551217;
const GIFT_PRODUCT_HANDLE = 'saddle-maintenance-kit';

const CartGift = {
  isSyncing: false,
  giftVariantId: null,

  async init() {
    await this.cacheGiftVariantId();
    this.bindEvents();
    setTimeout(() => this.checkAndSync(), 500);
  },

  async cacheGiftVariantId() {
    try {
      const res = await fetch(`/products/${GIFT_PRODUCT_HANDLE}.js`);
      if (!res.ok) { console.error('[CartGift] Gift product not found:', GIFT_PRODUCT_HANDLE); return; }
      const product = await res.json();
      this.giftVariantId = product.variants[0].id;
    } catch(e) {
      console.error('[CartGift] Failed to cache gift variant:', e);
    }
  },

  bindEvents() {
    // Fires immediately when a new variant is added
    document.addEventListener('on:cart:add', () => this.checkAndSync());

    // Fires on any cart change (remove, quantity)
    document.addEventListener('on:cart:change', () => this.checkAndSync());

    // Re-lock gift controls after drawer re-renders
    document.addEventListener('on:cart:after-merge', () => this.lockGift());

    const observer = new MutationObserver(() => this.lockGift());
    const cartDrawer = document.querySelector('[id*="cart-drawer"], [class*="cart-drawer"], cart-drawer');
    if (cartDrawer) observer.observe(cartDrawer, { childList: true, subtree: true });
  },

  refreshCartDrawer() {
    const events = ['dispatch:cart-drawer:refresh', 'cart:refresh', 'theme:open-cart-drawer'];
    const targets = [window, document, document.documentElement, document.body];
    targets.forEach(target => {
      events.forEach(name => {
        try { target.dispatchEvent(new CustomEvent(name, { bubbles: true })); } catch(e) {}
      });
    });
    const drawer = document.querySelector('cart-drawer, [id*="CartDrawer"], #cart-drawer');
    if (drawer && typeof drawer.refresh === 'function') drawer.refresh();
    if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents();
  },

  async checkAndSync() {
    if (this.isSyncing) return;
    this.isSyncing = true;

    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const items = cart.items;

      const hasTrigger = items.some(item =>
        TRIGGER_PRODUCT_IDS.map(Number).includes(Number(item.product_id))
      );
      const giftItem = items.find(item =>
        Number(item.product_id) === Number(GIFT_PRODUCT_ID)
      );
      const hasGift = !!giftItem;

      if (hasTrigger && !hasGift) {
        await this.addGift();
      } else if (!hasTrigger && hasGift) {
        await this.removeGift(giftItem);
      } else if (hasTrigger && hasGift) {
        this.lockGift();
      }

    } catch(e) {
      console.error('[CartGift] checkAndSync error:', e);
    } finally {
      setTimeout(() => { this.isSyncing = false; }, 800);
    }
  },

  async addGift() {
    if (!this.giftVariantId) {
      await this.cacheGiftVariantId();
      if (!this.giftVariantId) return;
    }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: this.giftVariantId, quantity: 1 }),
      });
      if (!res.ok) {
        const err = await res.json();
        console.error('[CartGift] Failed to add gift:', err);
        return;
      }
      // Refresh immediately — no delays
      this.refreshCartDrawer();
      this.lockGift();
    } catch(e) {
      console.error('[CartGift] addGift error:', e);
    }
  },

  async removeGift(giftItem) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftItem.key, quantity: 0 }),
      });
      if (!res.ok) {
        const err = await res.json();
        console.error('[CartGift] Failed to remove gift:', err);
        return;
      }
      this.refreshCartDrawer();
    } catch(e) {
      console.error('[CartGift] removeGift error:', e);
    }
  },

  lockGift() {
    document.querySelectorAll('.cart__item, .cart-item, [data-cart-item]').forEach(row => {
      const productIdAttr =
        row.dataset.productId ||
        row.querySelector('[data-product-id]')?.dataset.productId;

      if (!productIdAttr || Number(productIdAttr) !== Number(GIFT_PRODUCT_ID)) return;

      const removeBtn = row.querySelector(
        '.cart__remove, .cart-item__remove, [data-remove], .remove, a[href*="/cart/change"], button[data-line]'
      );
      if (removeBtn) removeBtn.style.display = 'none';

      const qtyInput = row.querySelector('input[type="number"], .quantity__input, [data-quantity-input]');
      if (qtyInput) {
        qtyInput.setAttribute('disabled', 'disabled');
        qtyInput.style.pointerEvents = 'none';
      }

      row.querySelectorAll('.quantity__button, [data-quantity-minus], [data-quantity-plus]').forEach(btn => {
        btn.style.display = 'none';
      });
    });
  }
};

document.addEventListener('DOMContentLoaded', () => CartGift.init());